export var emailPattern = {
    value: new RegExp(/\b[\w.-]+@[\w.-]+\.\w{2,4}\b/),
    message: 'Enter a valid email address.',
};
export var urlPattern = {
    value: new RegExp(/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/),
    message: 'Enter a valid url (must include http:// or https://)',
};
